import { makeStyles, createStyles } from '@material-ui/core'

export const useProjectMeFiltersStyles = makeStyles((theme) =>
  createStyles({
    filterContainer: {
      marginTop: 25,
      marginBottom: theme.spacing(3),

      [theme.breakpoints.up('md')]: {
        display: 'flex',
        alignItems: 'center'
      }
    },

    selectContainer: {
      display: 'none',

      [theme.breakpoints.up('md')]: {
        display: 'flex',
        flex: 1,
        alignItems: 'center'
      }
    },

    select: {
      width: 300,
      marginLeft: theme.spacing(3),

      [theme.breakpoints.down(1280)]: {
        width: 164
      },

      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: 0
      }
    },

    sort: {
      marginLeft: 'auto'
    },

    clearButton: {
      marginLeft: theme.spacing(3)
    },

    searchBar: {
      [theme.breakpoints.up('md')]: {
        maxWidth: 350
      }
    },

    defaultText: {
      position: 'absolute',
      left: 35,
      top: 8
    }
  })
)
